import { render, staticRenderFns } from "./scenario-table.vue?vue&type=template&id=2e08cbf7"
import script from "./scenario-table.vue?vue&type=script&lang=ts"
export * from "./scenario-table.vue?vue&type=script&lang=ts"
import style0 from "./scenario-table.vue?vue&type=style&index=0&id=2e08cbf7&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e08cbf7')) {
      api.createRecord('2e08cbf7', component.options)
    } else {
      api.reload('2e08cbf7', component.options)
    }
    module.hot.accept("./scenario-table.vue?vue&type=template&id=2e08cbf7", function () {
      api.rerender('2e08cbf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setup-overview/scenario-table.vue"
export default component.exports